import { get } from ".";

export const getDamagingEnergyApi = async () => {
  return await get(`predefine/damaging-energy`);
};

export const getUserRoleApi = async () => {
  return await get(`predefine/user-role`);
};

export const getCommentTypeApi = async () => {
  return await get(`predefine/comment-type`);
};

export const getCommentStatusApi = async () => {
  return await get(`predefine/comment-status`);
};

export const getReportStatusApi = async () => {
  return await get(`predefine/report-status`);
};

export const getContractTypeApi = async () => {
  return await get(`predefine/contract-type`);
};

export const getProjectStatusApi = async () => {
  return await get(`predefine/project-status`);
};